import React from "react";
import HeroSection from "../components/HeroSection";
import TrustStrip from "../components/TrustStrip";
import ServicesSection from "../components/ServicesSection";
import UnibuilderSpotlight from "../components/UnibuilderSpotlight";
import IndustriesGrid from "../components/IndustriesGrid";
import WhyChooseUs from "../components/WhyChooseUs";
import TalkToSupport from "../components/TalkToSupport";
import GrowingBusiness from "../components/GrowingBusiness";
import ReadyToBuild from "../components/ReadyToBuild";

// SEO related code
import SEO from "../SEO";

const Home = () => {
  return (
    <>
      <SEO
        title="AI Product Engineering: Custom AI & SaaS | Best Code Technology"
        description="AI-first product engineering company. We design, build, and scale LLM-powered automation, custom AI systems, and production SaaS platforms."
        keywords="AI product engineering, LLM development, custom AI software, SaaS development, AI automation, machine learning solutions"
        url="https://bestcodetechnology.in/"
      />
      <HeroSection />
      <TrustStrip />
      <ServicesSection />
      <UnibuilderSpotlight />
      <IndustriesGrid />
      <WhyChooseUs />
      <TalkToSupport />
      <GrowingBusiness />
      <ReadyToBuild />
    </>
  );
};

export default Home;
